import { useQuery } from '@apollo/client';
import { Queries } from '@shared/api';
import { NUM_CHAT_MESSAGES_TO_FETCH } from '@shared/styles';
import { API } from '@shared/types/api';
import { useCurrentUserId } from '@shared/util/hooks';
import { MBChatBannerComponent } from '../components/banner';

interface Props {
  channelSlug: string;
  creator: API.ShortUserFragment;
}

export function MBChatBanner({ channelSlug, creator }: Props) {
  const currentUserId = useCurrentUserId();

  // Note: copy-pasted from containers/thread.tsx
  const { data } = useQuery<API.ChannelChatThreadQuery, API.ChannelChatThreadQueryVariables>(
    Queries.channel.chatThread,
    {
      // Note(fant): we only fetch directly from cache since
      // Apollo otherwise would make an API request, updating
      // the channel's messages. This would cause the channel
      // to be refetched from the start just after older messages
      // have been fetched.
      fetchPolicy: 'cache-only',
      variables: {
        slug: channelSlug,
        since: null,
        limit: NUM_CHAT_MESSAGES_TO_FETCH,
      },
    },
  );

  if (!data?.channel) {
    return null;
  }

  return (
    <MBChatBannerComponent channel={data.channel} creator={creator} currentUserId={currentUserId} />
  );
}
